module.exports = __webpack_public_path__ + "img/produkt.b25af5a7.svg";